// @ts-check

import React from 'react';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import CheckIcon from '@liquidweb-dev/undercurrent/icons/lucide/Check';

/**
 * @param {Object} props
 * @param {import('@liquidweb-dev/club-sauce/public/asset/index.raw').LWApiPublicAssetReportRelatedTerminationActionsResultRaw} props.data
 */
const Addon = ({ data }) => {
	return (
		<Stack key={data.uniq_id} direction="row" alignItems="center" gap={100}>
			<CheckIcon
				strokeWidth={1.5}
				sx={{
					height: ({ size }) => size.xS,
					width: ({ size }) => size.xS,
					color: ({ vars }) => vars.palette.uc.danger.icon.main,
				}}
			/>
			<Stack direction="row" gap={50}>
				<Typography variant="body-sm">{data.title}</Typography>
			</Stack>
		</Stack>
	);
};

export default Addon;
